import { createFileRoute } from '@tanstack/react-router';

import { ArticleComposer } from '@/features/composer/ArticleComposer';
import { emptyComposerState } from '@/features/composer/types';
import { useRequireRole } from '@/lib/auth/useRequireRole';

export const Route = createFileRoute('/creator/write')({
  component: WriteRoute,
});

function WriteRoute() {
  const { loading } = useRequireRole(['creator'], { creatorStatus: 'approved' });
  if (loading) return null;
  return <ArticleComposer initial={emptyComposerState()} />;
}
